export default "__VITE_ASSET__8c7bc022__"